// @flow
import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
// eslint-disable-next-line no-duplicate-imports
import type { Router } from 'react-router';

import { setVersion } from '../../actions/version';

type Props = {
  router: Router;
  params: { version: string; };
  version: string;
  versions: Array<string>;
  children: Array<React$Element<*>>;
  setVersion: typeof setVersion;
};

@withRouter
@connect(({ app: { versions }, version: { string } }) => ({
  versions,
  version: string
}), {
  setVersion
})
export default class VersionContainer extends Component<void, Props, void> {
  componentDidMount(): void {
    const { props: { router, version, versions } } = this;

    if (versions.indexOf(version) >= 0) {
      this.props.setVersion(version);
      return;
    }

    router.replace('/not-found');
  }

  componentDidUpdate({ version: prevVersion }: Props): void {
    const { props: { router, version, versions } } = this;

    if (version !== prevVersion) {
      if (versions.indexOf(version) >= 0) {
        this.props.setVersion(version);
        return;
      }

      router.replace('/not-found');
    }
  }

  render() {
    return (
      <div>
        {this.props.children}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/VersionContainer/index.jsx